<template>
  <div class="footer">
    <!-- <p>国务院扶贫开发领导小组办公室主办</p> -->
    <p>全国扶贫宣传教育中心主办</p>
    <p>地址：北京市朝阳区太阳宫北街1号，邮编：100028</p>
    <p>版权所有：国务院扶贫开发领导小组办公室</p>
  </div>
</template>
<script>
export default {
  name: "helpFooter",
  data() {
    return {};
  },
  mounted() {}
};
</script>
<style scoped>
.footer {
  background-color: rgb(183, 31, 7);
  color: #ffffff;
  width: 100%;
  height: 120px;
  margin: 0px auto;
  padding: 37px 0;
  text-align: center;
}
.el-footer {
  padding:0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/helpFooter.vue